import { fileType } from '../../../../extensions/yfm';
import { FilesBatchUploadProcess } from '../../utils/upload';
import { createFileNode } from '../utils';
import { FileSkeletonDescriptor } from './skeleton';
export class YfmFilesUploadProcessBase extends FilesBatchUploadProcess {
    constructor(view, files, uploadHandler) {
        super(view, files, uploadHandler);
        this.createFile = createFileNode(fileType(this.view.state.schema));
    }
    createSkeleton() {
        return new FileSkeletonDescriptor(this.getSkeletonInitPos());
    }
    async createPMNode(res) {
        return this.createFile(res);
    }
}
